import { createSelector } from 'reselect';

import { getState as getParent } from 'modules/notifications/selectors/ui';

export const getState = createSelector(getParent, ({ dropdown } = {}) => dropdown);
